import React from 'react'
import Col from 'antd/lib/col'
import Row from 'antd/lib/row'
import Form from 'antd/lib/form'
import Input from 'antd/lib/input'
import Select from 'antd/lib/select'
import QuestionCircleOutlined from '@ant-design/icons/QuestionCircleOutlined'
import { maximumTimePeriodRule } from './Rules'
import { onBlurScrollNumber, onFocusScrollNumber } from 'components/Utils/price'
import PageHeader from 'antd/lib/page-header'
import Tooltip from 'antd/lib/tooltip'
import InputNumber from 'antd/lib/input-number'
import styled from '@emotion/styled'

interface TimePeriodProps {
  disabled?: boolean
  timePeriodUnitChangeHandler: () => void
}

const TimePeriod = ({
  disabled = false,
  timePeriodUnitChangeHandler
}: TimePeriodProps) => {
  return (
    <Row>
      <Col span={12}>
        <Row className='_mb-0'>
          <PageHeader
            title='Pre-order time period'
            className='settings-title'
          />
          <Tooltip
            placement='right'
            title={
              <span>
                The pre-order period allows you to specify how far in advance a
                customer can place an order.
                <br />
                <br />
                The maximum period can be set to 90 Days, 12 Weeks or 6 Months.
              </span>
            }
          >
            <QuestionCircleOutlined style={{ paddingBottom: 20 }} />
          </Tooltip>
        </Row>
      </Col>
      <Col span={12}>
        <Input.Group>
          <Row justify='end' gutter={16}>
            <Col style={{ width: '85px' }}>
              <Form.Item
                name='time_period_amount'
                rules={maximumTimePeriodRule}
              >
                <StyledInputNumber
                  type='number'
                  required
                  min={1}
                  disabled={disabled}
                  onFocus={onFocusScrollNumber}
                  onBlur={onBlurScrollNumber}
                />
              </Form.Item>
            </Col>
            <Col style={{ width: '240px' }}>
              <Form.Item name='time_period_unit'>
                <Select
                  disabled={disabled}
                  onChange={timePeriodUnitChangeHandler}
                >
                  <Select.Option value='day'>Day(s)</Select.Option>
                  <Select.Option value='week'>Week(s)</Select.Option>
                  <Select.Option value='month'>Month(s)</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={2} />
          </Row>
        </Input.Group>
      </Col>
    </Row>
  )
}

const StyledInputNumber = styled(InputNumber)`
  width: 100%;

  .ant-input-number-handler-wrap {
    opacity: 1;

    .ant-input-number-handler {
      background-color: #f3f2f4;
    }
  }

  .ant-input-number-input-wrap {
    width: 100%;

    .ant-input-number-input {
      width: inherit;
    }
  }
`

export default TimePeriod
